import React from "react";
import ListSkeleton from "./ListSkeleton";
import ListItem from "./ListItem";


const ListCourses = ({isLoading, items}) => {
    return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3 lg:gap-6">
        {
            isLoading
                ? <ListSkeleton />
                : items.length > 0 ? items.map((item) => <ListItem
                    key={item.id}
                    id={item.id}
                    access={item.access}
                    code={item.code}
                    title={item.title}
                    price={item.price}
                    image={item.image}
                    active={item.active}
                    stickerNew={item.is_sticker_new}
                    stickerHit={item.is_sticker_hit}
                />) : <>Курсы не найдены</>
        }
    </div>
}

export default ListCourses;
